import { render, staticRenderFns } from "./ListagemCategoriasHeader.vue?vue&type=template&id=6a8497ae"
import script from "./ListagemCategoriasHeader.vue?vue&type=script&lang=js"
export * from "./ListagemCategoriasHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports